// extracted by mini-css-extract-plugin
export default {"host":"MediaLogosPanelBody_host__AzrcB"};